export default "__VITE_ASSET__CuVbQ7Mz__"